import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { RootStoreContext } from '../core/root-store';
import { UserRole } from '../user/user.type';
import { updateUserProfileInDatabase } from '../user/user.service';
import RoleSelectionUi from './ui/role-selection.ui';

const RoleSelectionContainer = observer(() => {
  const rootStore = useContext(RootStoreContext);
  const navigate = useNavigate();

  const updateRole = async (role: string) => {
    if (rootStore.userStore.user) {
      rootStore.onboardingStore.updateField('role', role);

      rootStore.userStore.updateUserData({ role: role as UserRole });

      await updateUserProfileInDatabase(rootStore.userStore.user.uid, {
        role: role as UserRole,
      });

      navigate('/onboarding');
    }
  };

  return (
    <RoleSelectionUi
      onUpdateRole={updateRole}
    />
  );
});

export default RoleSelectionContainer;
